export const pedido = {
    numPedido: 'EBELN', // Número do Pedido
    matAcabado: 'MATNR_ACABADO', // Material Acabado
    matPedido: 'MATNR_PED', // Material Pedido
    minutos: 'MINUTOS', // Minutos
    cor: 'COR', // Minutos
    fornecedor: 'LIFNR',
    quantidade: 'MENGE',
    status: 'INSITUAC',
    dataCriacao: 'BUDAT',
    dataPrev: 'DTAUD',
    descEspecie: 'ESPECIEDESC',
    categoria: 'J_4KRCAT',
    tipoMaterial: 'MTART',
    node: 'NODE_TEXT',
    listaCritica: 'LISTA_CRITICA',
    remessaFinal: 'REMESSA_FINAL',
    periodoPlan: 'PERPLAN',
    tamanho: 'TAMANHO',
    colecao: '_-AFS_-COLLECTION',
    estacao: 'J_3ASEAN',
    cStatusQM: 'STATUS_APROV',
    cDataQM: 'DATA_APROV',
    cNotaQM: 'QMNUM',
    opSeg: 'PROX_OPERACAO',
    dataAud: 'DTAUD',
    obsAud: 'OBS',
    statusAud: 'STATUS_AUDITORA',
    dataEstatistica: 'DATA_ESTATISTICA',
    notaRetorno: 'NOTA_RETORNO',
    nota5903: 'NOTA_5903',
    minutos5903: 'QTDE_MIN_5903',
    nfeNumNota5903: 'NFENUM_5903',
    pecas5903: 'QTDE_5903',
    descCota: 'DESC_COTA',
    dtPrecon: 'DTPRECON',
};

export const auth = {
    PRESTSERV_GERENCIAR_QUALIDADE: 'PRESTSERV_GERENCIAR_QUALIDADE',
    PRESTSERV_GERENCIAR_AUDITORIA: 'PRESTSERV_GERENCIAR_AUDITORIA',
};

export const earlyAdopters = [
    // 'ja20549',
    // 'ja14784',
    // 'ja17449',
    // 'ja20737',
    // 'ja17589',
    // 'ja30607',
    'lyncas.david',
    'cast.felipe',
    // 'ja33684',
    // 'ja22533', //Aline
    // 'ja1390',
    'ja6113', //Aline de Oliveira
    'ja4912', //Luana
    'ja28327', //Jaqueline
    'ja31650', //Robson
];

export const faccoesIndependentes = [
    '0001001425', // STAR BEST
    '0001000338', // PETRONILA WEINFUTER ME
    '0001014588', // CONFECCOES UBER - EIRELI
    '0001032857', // CJ CONFECÇÃO LTDA
    '0001020058', // LENISE KLEMANN ERDMANN
    '0001000496', // DF BRASIL CONFECCOES LTDA-ME
    '0001033607', // EDLLY CONFECCOES LTDA
    '0001032869', // JB FACCAO LTDA
    '0001034178', // CA&MILA CONFECCAO LTDA
    '0001019723', // JAMD CONFECCAO LTDA - ME
    '0001028350', // MARA TEXTIL LTDA
    '0001033519', // 4S INDUSTRIA DE CONFECCOES LTDA
    '0001027276', // MIKAJON CONFECCOES LTDA
    '0001034059', // ZILLI CONFECCOES
    '0001000185', // CONFECCOES BUMERANGUE LTDA ME
    '0001000473', // CHARLES WOLTER FACCAO ME
    '0001029185', // BH CONFECCOES LTDA
    '0001000555', // CONFECCOES RINASI LTDA ME
    '0001022049', // STAR BLU CONFECCOES LTDA ME
    '0001000207', // MALHAS PLUSBELLI LTDA -EPP
    '0001000548', // CONFECCOES CRISMAIRA LTDA-ME
    '0001032864', // THAURUS CONFECCOES
    '0001033595', // ODORIZZI CONFECCOES LTDA
    '0001033660', // IVO TOTTENE
    '0001020652', // FACCAO IBIRAMA LTDA
    '0001020306', // AG FACCAO LTDA ME
    '0001032037', // DZ7 CONFECCOES LTDA
    '0001029151', // DANI & MARI CONFECCOES EIRELI
    '0001034010', // PEDRO PAULO CONFECCOES LTDA
    '0001027129', // CONFECCOES L D M L EIRELI
    '0001032789', // VOTUM FACCAO LTDA
    '0001024297', // FACCAO AVITEX EIRELI.
    '0001019779', // TS CONFECCOES LTDA - ME
    '0001014229', // SANDRA SPERAFICO EIRELI
    '0001024223', // VR CONFECCOES LTDA
    '0001014274', // ROSELETE JUNG - ME
    '0001000197', // CONFECCOES ENETTE LTDA
    '0001026258', // MARIA MADALENA DE OLIVEIRA CONFECCAO
    '0001020224', // INDUSTRIA E COM DE CONFECCOES HOINATZ LTDA
    '0001000525', // MAFER CONFECCAO LTDA
    '0001000482', // BALBINOTTI FACCAO DE PECAS VEST. LTDA ME
    '0001021587', // RODRIGO SCHMOLLER ME
    '0001000506', // THALUU CONFECCOES LTDA-ME
    '0001000561', // CONFECCOES GEVAN LTDA - ME
    '0001000247', // CINQUENTA CONFECCOES LTDA EPP
    '0001000477', // ALTERNATIVA COM.E IND.DE CONFECCOES LTDA ME
    '0001014504', // LAILLA FACÇÃO LTDA.
    '0001000457', // MARIA LUCIA CONFECCOES LTDA EPP
    '0001034294', // FACCAO RAYSSA LTDA
    '0001032876', // NANDO CONFECCOES LTDA
    '0001000464', // NEVANA TEXTIL LTDA-EPP
    '0001000478', // DRIJU CONFECCOES LTDA
    '0001033636', // JP. DENILZA CONFECCOES LTDA
    '0001032888', // NENES FACCAO LTDA
    '0001027949', // SLS FACCAO EIRELI
    '0001027257', // VANSILVA FACCAO LTDA
    '0001032823', // C&C CONFECCOES
    '0001027230', // NATIVA FACCAO EIRELI FILIAL
    '0001008982', // CONFECCOES LUIMARI LTDA - ME
    '0001025975', // XUXA CONFECCOES LTDA
    '0001014504', // LAILLA FACÇÃO LTDA.
    '0001000419', // LACHRI LASER LTDA.
    '0001032877', // CONFECCOES AGADU
    '0001033491', // KF CONFECCOES
    '0001035529', // ROSE CLEIA DOS SANTOS LTDA
    '0001036092', // AMANDA CRISTINA MELLO
    '0001036219', // CONECTAI CONFECCOES LTDA
    '0001035338', // FORTE TEX LTDA
];
